import { render } from "./HtzIcons.vue?vue&type=template&id=2120d013"
import script from "./HtzIcons.vue?vue&type=script&lang=js"
export * from "./HtzIcons.vue?vue&type=script&lang=js"

import "./HtzIcons.vue?vue&type=style&index=0&id=2120d013&lang=css"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__